module.exports = __webpack_public_path__ + "static/media/functional_element_with_snv_by_cancer_merged_Mar_22_2022_unique_geneName.e8496695.csv";